module.exports = __webpack_public_path__ + "img/Winnie Sung.94eb47ef.jpg";